var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoloniex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 123 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.973H6.58v-5.499h3.888c3.07 0 4.814-2.12 4.814-4.615 0-2.497-1.722-4.617-4.814-4.617H4v14.73zM12.634 9.86c0 1.412-1.06 2.34-2.518 2.34H6.582V7.517h3.534c1.457 0 2.517.927 2.517 2.34zm5.52 2.76c0 4.394 3.113 7.618 7.53 7.618 4.417 0 7.53-3.224 7.53-7.62 0-4.394-3.113-7.618-7.53-7.618-4.417 0-7.53 3.224-7.53 7.62zm12.41 0c0 3.025-1.92 5.321-4.88 5.321-2.982.001-4.88-2.295-4.88-5.32 0-3.049 1.898-5.323 4.88-5.323 2.96 0 4.88 2.274 4.88 5.322zm6.518 7.353h9.077v-2.275h-6.494V5.243h-2.584v14.73zM48.54 12.62c0 4.394 3.113 7.618 7.53 7.618 4.417 0 7.53-3.224 7.53-7.62C63.6 8.225 60.488 5 56.07 5c-4.417 0-7.53 3.224-7.53 7.62zm12.41 0c0 3.025-1.92 5.321-4.88 5.321-2.98.001-4.88-2.295-4.88-5.32 0-3.049 1.9-5.323 4.88-5.323 2.96 0 4.88 2.274 4.88 5.322zm16.79 7.353h2.494V5.243h-2.583v10.446L70.12 5.242h-2.65v14.73h2.584V9.24l7.685 10.733zm7.004 0h2.584V5.243h-2.583v14.73h-.001zm7.096 0h10.092v-2.275h-7.508v-4.085h7.354v-2.275h-7.354v-3.82h7.508V5.243H91.84v14.73zm23.975 0h3.092l-5.5-7.575 5.168-7.155h-3.113l-3.777 5.41-3.798-5.41h-3.092l5.19 7.177-5.52 7.553h3.09l4.13-5.764 4.13 5.763z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoloniex);
export default __webpack_public_path__ + "static/media/poloniex.6aecfae4012c4c504f0ea123ff737344.svg";
export { ForwardRef as ReactComponent };